{
  "actions": "Actions",
  "browserConnect": "Se connecter à une MV",
  "GB": "Go",
  "listOfVMs": "Liste des machines virtuelles",
  "myVMs": "Mes machines virtuelles (MV)",
  "noVms": "Vous n'avez aucune machine virtuelle des SAD.",
  "noVmsP1": "Selon les besoins de votre projet, vos analyses pourraient en tirer profit.",
  "noVmsP2": "Pour initier le processus, appuyez sur « Démarrer un nouveau projet », et nous déterminerons si une machine virtuelle des SAD répondrait à vos besoins.",
  "size": "Taille",
  "startVM": "Démarrer la machine virtuelle",
  "startVMtitle": "Démarrer la MV",
  "status": "État",
  "stopVM": "Arrêter la machine virtuelle",
  "stopVMtitle": "Arrêter la MV",
  "VDLVMs": "Machines virtuelles du Laboratoire virtuel de données (LVD)",
  "VmLoadError1": "Un problème est survenu au moment de charger les machines virtuelles. Veuillez réessayer plus tard ou communiquer avec ",
  "VmLoadErrorLink": "notre équipe de soutien technique",
  "VmLoadError2": " si le problème persiste.",
  "VM": "La MV",
  "VMName": "Nom de la MV",
  "VMStarted": "a démarré avec succès",
  "VMStarting": "démarrage en cours",
  "VMConnected": "s'est connecté avec succès",
  "VMStopping": "en cours d'arrêt (libération)….",
  "VMStopped": "arrêt réussi",
  "creating": "Création en cours",
  "starting": "Démarrage en cours",
  "running": "Exécution en cours",
  "stopping": "En cours d'arrêt",
  "stopped": "Arrêté",
  "deallocating": "En cours d'arrêt",
  "deallocated": "Arrêter",
  "updating": "Mise à jour",
  "failed": "Échec",
  "succeeded": "Opération réussie",
  "deleting": "Suppression",
  "migrating": "Migration",
  "uploadFiles": "Télécharger fichiers au MV",
  "downloadFiles": "Télécharger fichiers du MV",
  "autoShutDownSettings": "Paramètres d'arrêt automatique",
  "forgotPassword": "Mot de passe de la MV oublié",
  "vmMoreActionsTitle": "Plus",
  "vmAutoShutdownAt": "Arrêt automatique à : ",
  "vmAutoShutdownNotSet": "L'arrêt automatique n'est pas réglé",
  "timezonePacificAbbr": "HNP",
  "timezoneMountainAbbr": "HNR",
  "timezoneCentralAbbr": "HNC",
  "timezoneEasternAbbr": "HNE",
  "timezoneAtlanticAbbr": "HNA",
  "timezoneNewfoundlandAbbr": "HNT",
  "viewAutoShutdownSettingsFor": "Afficher les paramètres d'arrêt automatique pour",
  "autoShutdownSettingsSavedPt1": "Les paramètres d'arrêt automatique de la MV",
  "autoShutdownSettingsSavedSuccessfullyPt2": "ont été enregistrés",
  "autoShutdownSettingsNotSavedSuccessfullyPt2": "n'ont peut-être pas été enregistrés. Veuillez actualiser la page et revoir les paramètres d'arrêt automatique"
}
